
<template>
  <div class="page-commercial-products">
    <tabbed-view :tabs="tabs" fixed-title=" "/>
  </div>
</template>

<script>

import TabbedView from '@/views/components/tabs/TabbedView';

export default {
  name: "CommercialProducts",
  components: {
    TabbedView,
  },
  data() {
    return {
      title: null,
      tabs: [
        {
          label: 'Commercial Products FUW',
          route: 'company.commercial-products.fuw.list',
        },
        {
          label: 'Commercial Products IPR Producer',
          route: 'company.commercial-products.ipr-producer.list',
        },
        {
          label: 'Commercial Products IPR Coverholder',
          route: 'company.commercial-products.ipr-coverholder.list',
        },
      ]
    };
  },
}
</script>
